<template>
  <v-card class=" ma-0 pb-5 secondary__green_chosen info-list">
    <v-card-title class="h4-headline pt-6 pl-6">
      {{ $t(`Tenders.AboutLot`) }}
    </v-card-title>
    <v-card-text class="py-0">
      <v-list class="py-0">
        <v-row no-gutters>
          <v-col>
            <v-list-item class="px-1">
              <v-list-item-content class="pt-2 pb-3">
                <v-list-item-subtitle class="h9-label px-0 ">
                  {{ $t('Catalog.Amount') }}
                </v-list-item-subtitle>
                <v-list-item-title class="h7-text">
                  {{ formSum(item.quantity) }} {{ item.unit ? item.unit.title : '–' }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-1">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0 ">
                  {{ $t('Tenders.RatesStep') }}
                </v-list-item-subtitle>
                <v-list-item-title class="h7-text">
                  {{ formSum(item.minimalStepPercent) }}
                  <template v-if="tender">
                    <span v-if="tender.biddingType && tender.biddingType.tenderingForPercentage">%</span>
                    <span v-else>
                      {{ tender.fixedStep ? (tender.currency ? tender.currency.title : tender.tenderCurrency) || '–' : '%' }}
                    </span>
                  </template>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col>
            <v-list-item class="px-2">
              <v-list-item-content class="py-2">
                <v-list-item-subtitle class="h9-label px-0 ">
                  {{ $t('Tenders.StartingPrice') }}
                </v-list-item-subtitle>
                <v-list-item-title class="h7-text">
                  {{ formSum(item.initialAmount) }}  {{ tender && tender.currency ? tender.currency.title : '–' }}
                  <CurrencyConversionTooltip
                    v-if="item.initialAmount || item.startAmount"
                    :currency="tender.currency ? tender.currency.title : tender.tenderCurrency"
                    :current-id="tender.nbuCurrency ? tender.nbuCurrency.currencyId : null"
                    :nbu-currency="tender.nbuCurrency"
                    :price="item.initialAmount || item.startAmount || 0 "/>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-2">
              <v-list-item-content>
                <v-list-item-subtitle class="h9-label px-0 ">
                  {{ $t('Tenders.TotalPrice') }}
                </v-list-item-subtitle>
                <v-list-item-title class="h7-text">
                  {{ formSum(item.quantity * item.initialAmount) }} {{ tender && tender.currency ? tender.currency.title : '–' }}
                  <CurrencyConversionTooltip
                    v-if="item.initialAmount || item.startAmount"
                    :currency="tender.currency ? tender.currency.title : tender.tenderCurrency"
                    :current-id="tender.nbuCurrency ? tender.nbuCurrency.currencyId : null"
                    :nbu-currency="tender.nbuCurrency"
                    :price="(item.initialAmount || item.startAmount || 0 ) * item.quantity"/>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import CurrencyConversionTooltip from 'components/common/elements/CurrencyConversionTooltip.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'lotInfoBar',
  mixins: [ modalMixin ],
  props: {
    item: Object,
    tender: Object
  },
  components: {
    CurrencyConversionTooltip
  }
}
</script>
